import PageBody from "../PageBody";
import NewCompnay from "../components/pages/companies/NewCompnay";

const NewCompany = () => {
  return (
    <PageBody>
      <NewCompnay />
    </PageBody>
  );
};

export default NewCompany;
